import { $Q, stringToHTML } from 'graditify-utils';
import api from '../services/api';

export class CollectionCard {
  constructor() {
    this.init();
  }

  /**
   * Initializes the function.
   */
  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.listenUrlSubcollections();
      this.listenCards();
    });
    window.addEventListener('popstate', () => {
      const url = new URL(window.location.href);
      if (!url.searchParams.get('subcollection')) {
        window.location.reload();
      }
    });
  }

  /**
   * Retrieves all the cards from the DOM with the class 'collection-item'.
   */
  cards() {
    const cards = document.querySelectorAll('.collection-item');
    return cards;
  }

  /**
   * Listens for click events on the cards and handles the active cards.
   */
  listenCards() {
    const cards = this.cards();
    cards.forEach((card) => {
      card.addEventListener('click', () => {
        this.handleActiveCards(card);
      });
    });
  }

  /**
   * Fetches a collection using the given data handle.
   *
   * @param {type} dataHandle - The handle used to identify the collection.
   * @param {type} searchParams - The search parameters.
   */
  fetchCollection(dataHandle, searchParams) {
    const url = new URL(window.location.href);
    const urlSerialized = new URL(window.location.href);
    const collectionFilters = this.getUrlParams(url);
    urlSerialized.search = new URLSearchParams(collectionFilters);
    const search = searchParams || urlSerialized.search;
    this.getCollectionSection(dataHandle, search);
    this.getCollectionInfo(dataHandle);
  }

  /**
  * Handles the active cards.
  *
  * @param {Object} card - The card element.
  * @param {String} searchParams - The search parameters.
  */
  handleActiveCards(card, searchParams) {
    const cardList = $Q('.collection-cards');
    if (card.classList.contains("active")) {
      card.classList.remove("active");
      this.fetchCollection(card.getAttribute('data-origin'), "");
      this.removeCollectionUrl();
      return;
    }
    const cards = this.cards();
    cards.forEach((card) => {
      card.classList.remove('active');
    });
    card.classList.add('active');
    if (cardList && cardList.length) {
      cardList.prepend(card.parentNode);
    }
    this.fetchCollection(card.getAttribute('data-handle'), searchParams);
    this.updateCollectionUrl(card.getAttribute('data-handle'));
    window.localStorage.removeItem('subcollection');
  }

  /**
   * Retrieves the collection section for a given collection handle.
   *
   * @param {string} collectionHandle - The handle of the collection.
   * @param {string} searchParams - The search parameters.
   */
  async getCollectionSection(collectionHandle, searchParams = "") {
    const collectionSection = $Q("#list-products");
    if (!collectionSection) return;
    const sectionId = collectionSection.getAttribute('data-url');
    const collectionUrl = `/collections/${collectionHandle}${searchParams}`;
    const sectionApi = await api.shopifySectionByUrl(collectionUrl, sectionId,
                                                    searchParams.length ? "&section_id" : undefined);               
    const sectionHtml = stringToHTML(sectionApi);
    const collectionContainer = $Q(".shopify-section.collection");
    if (collectionContainer) {
      collectionContainer.outerHTML = sectionHtml.innerHTML;
    }
  }

  /**
   * Retrieves information about a collection.
   *
   * @param {string} collectionHandle - The handle of the collection.
   */
  async getCollectionInfo(collectionHandle) {
    const collectionUrl = `/collections/${collectionHandle}`;
    const sectionApi = await api.shopifySectionByUrl(collectionUrl, 'collection-info');
    const sectionHtml = stringToHTML(sectionApi);
    const collectionContainer = $Q(".shopify-section.main-collection__heading");
    if (collectionContainer) {
    collectionContainer.outerHTML = sectionHtml.innerHTML;
    }
  }

  /**
   * Updates the collection URL with a new subcollection handle.
   *
   * @param {type} subcollectionHandle - The handle of the subcollection.
   */
  updateCollectionUrl(subcollectionHandle) {
    const newUrl = new URL(window.location.href);
    if (!newUrl.pathname.includes(subcollectionHandle)) {
      newUrl.searchParams.set('subcollection', subcollectionHandle);
      window.history.pushState({}, null, newUrl.href);
      this.saveCollectionSelected();
    }
  }

  /**
   * Remove the 'subcollection' parameter from the
   * URL and update the browser history.
   */
  removeCollectionUrl() {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('subcollection');
    window.history.pushState({}, null, newUrl.href);
    window.localStorage.removeItem('subcollection');
  }

  /**
   * Listens for changes in the URL subcollections and performs
   * an action if a subcollection is present.
   */
  listenUrlSubcollections() {
    const url = new URL(window.location.href);
    const collectionFilters = this.getUrlParams(url);
    const urlSerialized = new URL(window.location.href);
    let subcollection = url.searchParams.get('subcollection');
    subcollection = subcollection || window.localStorage.getItem('subcollection');
    urlSerialized.search = new URLSearchParams(collectionFilters)
    if (subcollection) {
      const collectionItem = $Q(`.collection-item[data-handle="${subcollection}"]`);
      if (collectionItem) {
        this.handleActiveCards(collectionItem, urlSerialized.search);
      }
    } else {
      const { pathname } = url;
      const actualCollection = pathname.replace("/collections/", "").trim();
      const collectionItem = $Q(`.collection-item[data-handle="${actualCollection}"]`);
      if (collectionItem) {
        this.handleActiveCards(collectionItem, urlSerialized.search);
      }
    }
  }

  /**
   * Saves the selected collection to the local storage.
   */
  saveCollectionSelected() {
    const url = new URL(window.location.href);
    const subcollectionParam = url.searchParams.get('subcollection');
    window.localStorage.setItem('subcollection', subcollectionParam);
  }

  /**
   * Retrieves the URL parameters from the current page URL.
   *
   * @return {URL} The URL object representing the current page URL.
   */
  getUrlParams(url) {
    const collectionParams = new URLSearchParams(url.search);
    const collectionOrder = {
      sort_by: collectionParams.get('sort_by'),
    };
    const collectionPagination = {
      page: collectionParams.get('page'),
    }
    let collectionFilters = {}
    collectionParams.forEach((val, key) => {
      if (key.includes('filter')) {
      collectionFilters = {
        ...collectionFilters,
        [key]: val,
      }
      }
    });
    collectionFilters = {
      ...collectionFilters,
      ...collectionOrder,
      ...collectionPagination,
    }
    return collectionFilters;
  }
}
